// This follows patterns according to date-fns library
export const MONTH_DAY_YEAR_TIME_FORMAT = 'MMM dd, yyyy, hh:mm a';

export const YEAR_MONTH_DAY_HYPHEN_FORMAT = 'yyyy-MM-dd';
export const YEAR_MONTH_DAY_TIME_HYPHEN_FORMAT = 'yyyy-MM-dd hh:mm:ss';

export const MONTH_DAY_YEAR_FORMAT = 'PP';

export const MONTH_YEAR_FORMAT = 'MMMM yyy';

export const IPV4_REGEX = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/;
export const PHONE_REGEX = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
export const PORT_NUMBER_REGEX = /^([0-9]{1,4}|[1-5][0-9]{4}|6[0-4][0-9]{3}|65[0-4][0-9]{2}|655[0-2][0-9]|6553[0-5])$/;

export const sortingOrder = {
  ASCENDING: 'ASC',
  DESCENDING: 'DESC',
};

// Chart-Js Constants
export const CHART_JS_ROOT_ID = 'chartjs-tooltip';
export const CUSTOM_CHART_JS_CLASS = 'chartjs-custom-tooltip';
export const LEGEND_CONTAINER_ID = 'legend-container';

export const LANG = {
  ENGLISH: 'en',
  FRENCH: 'fr',
};
